/**
 * Hero on the front page
 **/
app.add({

    onLoad: function(){
        this.hero = $('.front-page-hero').map(this.create);
    },

    onFallaciesLoad: function(){

        this.hero.each(function(){
            //check if one of mouse is over a button on load
            var fallacy = $('.front-page-hero .square-button:hover')[0];
            if (fallacy) {
                this.item.setActive.call(fallacy);
            } else {
                this.next();
            }
        });

        $('.waits-for-hero').removeClass('waits-for-hero');
    },

    create: function(){

        var fallacies = app.fallacies;

        var item = {
            setActive: function(e){
                var fallacy = fallacies.find(this.getAttribute('data-key'));
                if (!fallacy || e && fallacy === fallacies.current()) {
                    return;
                }
                fallacies.current(fallacy.order);

                var activeItem = hero.items.filter('.active');
                if (activeItem.length) {
                    var activeFallacy = fallacies.find(activeItem.attr('data-key'));
                    app.notify('homeMakeInactive', {item: activeItem, fallacy: activeFallacy});
                }

                hero.items.removeClass('active');
                hero.article.hide(0, hero.refresh);

                this.className += ' active';
                app.notify('homeMakeActive', {item: $(this), fallacy: fallacy});
            },
            preventDefault: function(e){
                e.preventDefault();
            }
        }

        var hero = {
            timer: undefined,
            items: $('.front-page-hero .square-button'),
            article: $('.front-page-hero-article'),
            item: item,

            resume: function(){
                if (hero.timer) {
                    clearTimeout(hero.timer);
                }
                hero.timer = setTimeout(hero.next, 7000);
            },

            stop: function(){
                clearTimeout(hero.timer);
            },

            next: function(){
                fallacies.next();
                var next = hero.items[fallacies.current().order];
                item.setActive.call(next);
                hero.resume();
            },

            refresh: function(){
                var fallacy = fallacies.current();
                hero.article.empty()
                            .append('<h2>'+fallacy.title+'</h2>')
                            .append('<p>'+fallacy.first+'</p>')
                            .append('<hr>')
                            .show();
            },

            setDetailedTemplate: function(html){
                var template = /<!--detailed-template-->([\s\S]+)<!--detailed-template-->/.exec(html);
                if (!template) {
                    throw new Error('failed to get detailed template');
                }
                hero.detailedTemplate = $(template.pop());
            },

            selected: function(){
                var fallacyKey = this.getAttribute('data-key'),
                    fallacy = null;

                if (fallacyKey) {
                    fallacy = fallacies.find(fallacyKey);
                }

                if (!fallacy) {
                    fallacy = fallacies.current();
                }
                else {
                    item.setActive.call(this);
                }

                if (!fallacy) {
                    return;
                }

                hero.items.off('click.selected');

                // $('body').addClass('pause-animation');
                var miscimage_url = $('#miscpage_image').attr('src');
                app.header.change(miscimage_url);

                var clicked = $(this);
                var animated = clicked.clone();
                clicked.css('visibility', 'hidden');

                var container = $('.container.main');
                //build new layout and calculate destination's coordinates
                var article = hero.detailedTemplate;
                article.prependTo(container);
                article.find('.square-button').html(clicked.html());

                var enlarged = article.find('.square-button');
                var destination = enlarged.offset();
                destination['font-size'] = '2em';

                article.hide();
                enlarged.css('visibility', 'hidden');

                container.velocity({opacity: 0}, 250);

                //animate clicked picture to the center
                animated.appendTo('body')
                        .css('position', 'absolute')
                        .offset(clicked.offset())
                        .velocity(destination, {duration: 250*2, easing: [500,20]});


                setTimeout(function(){
                    app.notify('fallacyDetailedCreate', fallacy);
                    //cleanup old content. the first child is our new content (article)
                    container.children().not(":first-child").remove();
                    container.velocity({opacity: 1}, 250);
                }, 250);

                setTimeout(function(){
                    animated.remove();
                    enlarged.css('visibility', 'visible');
                    // $('body').removeClass('pause-animation');
                }, 250*2);
            }
        };

        hero.items.on('mouseenter', item.setActive);
        hero.items.on('mouseenter', hero.stop);
        hero.items.on('mouseleave', hero.resume);

        hero.items.on('click', item.preventDefault);
        hero.items.on('click.selected', hero.stop);
        hero.items.on('click.selected', hero.selected);

        // $.get(hero.items.attr('href'), hero.setDetailedTemplate);
        var html = $('#detailed-template').html();
        hero.setDetailedTemplate(html);

        return hero;
    }
});














// WEBPACK FOOTER //
// ./resources/assets/js/modules/front-page-hero.js